import React from 'react'
import './footer.css'
import {Link} from 'react-scroll'



const Footer = () => {
    return (
    <>
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">ElQaNaS</h1>
                <p>FullStack Developer</p>

                <ul className="footer__list">
                    <li>
                        <Link to='home' href='#' className="footer__link">Home</Link>
                    </li>

                    <li>
                        <Link to='skills' href='#' className="footer__link">Skills</Link>
                    </li>

                    <li>
                        <Link to='projects' href='#' className="footer__link">Projects</Link>
                    </li>
                </ul>

                <ul className="footer__social">
                    <a href="https://www.linkedin.com/in/ahmed-azzoz-aa1873246/" rel="noreferrer" target="_blank" className="footer__social-link">
                        <i className="ri-linkedin-box-line"></i>
                    </a>
                    <a href="https://github.com/Ahmed-Azoz1" rel="noreferrer" target="_blank" className="footer__social-link">
                        <i className="ri-github-line"></i>
                    </a>
                    <a href="https://dribbble.com/" rel="noreferrer" target="_blank" className="footer__social-link">
                        <i className="ri-dribbble-line"></i>
                    </a>
                </ul>

                <span className="footer__copy">
                    &#169; Copyright ElQaNaS. All rights reserved
                </span>
            </div>
        </footer>
    </>
    )
}

export default Footer